var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-one"},[_c('div',{staticClass:"filter-bg"}),_c('div',{staticClass:"wrap-img"},[_c('img',{staticClass:"phone-img",attrs:{"src":require("../assets/img/2.png")}})])])
}]

export { render, staticRenderFns }